import type { Module } from 'vuex';
import { TradeGroup } from '@/types/TradeGroup';
import {RootState} from "@/store";

export interface TradeGroupsState {
  tradeGroups: TradeGroup[];
}

const tradeGroupsModule: Module<TradeGroupsState, RootState> = {
  namespaced: true,

  state: (): TradeGroupsState => ({
    tradeGroups: [],
  }),

  getters: {
    getById: (state) => (idTradeGroup: number): TradeGroup | undefined => {
      return state.tradeGroups.find(tradeGroup => tradeGroup.idTradeGroup === idTradeGroup);
    },
  },

  mutations: {
    setTradeGroups(
      state,
      payload: { tradeGroups: Record<number, any> }
    ) {
      state.tradeGroups = Object
        .values(payload.tradeGroups)
        .map(raw => TradeGroup.fromRaw(raw));
    },

    setTradeGroupCreate(
      state,
      payload: {
        idTradeGroup: number;
        name: string;
        telegram: string;
        timeframes: string;
        locked: boolean;
      }
    ) {
      const raw = {
        idTradeGroup: payload.idTradeGroup,
        name: payload.name,
        telegram: payload.telegram,
        timeframes: payload.timeframes,
        locked: payload.locked,
      };
      state.tradeGroups.push(TradeGroup.fromRaw(raw));
    },

    setTradeGroupUpdate(
      state,
      payload: {
        idTradeGroup: number;
        name?: string;
        telegram?: string;
        timeframes?: string;
        locked?: boolean;
      }
    ) {
      const tradeGroup = state.tradeGroups.find(tradeGroup => tradeGroup.idTradeGroup === payload.idTradeGroup);
      if (!tradeGroup) return;
      if (payload.name !== undefined) tradeGroup.name = payload.name;
      if (payload.telegram !== undefined) tradeGroup.telegram = payload.telegram;
      if (payload.timeframes !== undefined) tradeGroup.timeframes = payload.timeframes;
      if (payload.locked !== undefined) tradeGroup.locked = payload.locked;
    },

    setTradeGroupDelete(
      state,
      payload: { idTradeGroup: number }
    ) {
      state.tradeGroups = state.tradeGroups.filter(
        tradeGroup => tradeGroup.idTradeGroup !== payload.idTradeGroup
      );
    },

    setTradeGroupLock(
      state,
      payload: { idTradeGroup: number }
    ) {
      const tradeGroup = state.tradeGroups.find(tradeGroup => tradeGroup.idTradeGroup === payload.idTradeGroup);
      if (tradeGroup) tradeGroup.locked = true;
    },

    setTradeGroupUnlock(
      state,
      payload: { idTradeGroup: number }
    ) {
      const tradeGroup = state.tradeGroups.find(tradeGroup => tradeGroup.idTradeGroup === payload.idTradeGroup);
      if (tradeGroup) tradeGroup.locked = false;
    },
  },

  actions: {
    wsSetTradeGroups({ commit }, payload) {
      commit('setTradeGroups', payload);
    },
    wsTradeGroupCreate({ commit }, payload) {
      commit('setTradeGroupCreate', payload);
    },
    wsTradeGroupUpdate({ commit }, payload) {
      commit('setTradeGroupUpdate', payload);
    },
    wsTradeGroupDelete({ commit }, payload) {
      commit('setTradeGroupDelete', payload);
    },
    wsTradeGroupLock({ commit }, payload) {
      commit('setTradeGroupLock', payload);
    },
    wsTradeGroupUnlock({ commit }, payload) {
      commit('setTradeGroupUnlock', payload);
    },
  },
};

export default tradeGroupsModule; 